import { Link, useNavigate } from '@tanstack/react-router'
import { useDecks } from './queries'
import { DeckEditor } from './deck-editor'
import { DeckToolbar } from './deck-toolbar'
import { deckErrorText } from './errors'
import styles from './decks.module.css'

export function DeckPage({ deckId }: { deckId: string }) {
  const decks = useDecks()
  const navigate = useNavigate()
  const deck = decks.data?.items.find((d) => d.id === deckId)
  const uploadsEnabled = decks.data?.uploads_enabled ?? true

  if (decks.isPending) return <div className="spinner" aria-label="Загрузка" />
  if (decks.isError) return <p className={styles.error}>{deckErrorText(decks.error)}</p>
  if (!deck) {
    return (
      <div className="card-panel">
        <h2>Колода не найдена</h2>
        <p className="muted">Возможно, её удалили.</p>
        <Link to="/decks">Все колоды</Link>
      </div>
    )
  }

  return (
    <div>
      <DeckToolbar deck={deck} uploadsEnabled={uploadsEnabled} canSetDefault={decks.data.can_set_default} onDeleted={() => void navigate({ to: '/decks', replace: true })} />
      <DeckEditor deck={deck} uploadsEnabled={uploadsEnabled} />
    </div>
  )
}
